module.exports = __webpack_public_path__ + "img/squenda.614fb0a4.png";